

export class SharedSubventionCriteriaGetCriteriaAction {
    static type = '[SharedSubventionCriteria] get criteria';
}
